import { camelCase as lodashCamelCase } from 'lodash';

/**
 * Converts a string to camel case.
 *
 * @param str The string to convert.
 * @returns The camel cased string.
 */
export const toCamelCase = (str: string): string => lodashCamelCase(str);
